import { useContext } from 'react';
import { Tabs } from '../constants/Tabs';
import { GrowIntelContext } from '../context/context';

type IUseTabs = () => {
  tabs: typeof Tabs;
};

export const useTabs: IUseTabs = () => {
  const context = useContext(GrowIntelContext);
  if (!context)
    return {
      currentTab: Tabs[0].value,
      setCurrentTab: () => {},
      tabs: Tabs,
    };
  return {
    tabs: Tabs,
  };
};
